import { initSplitApi } from './init'
import * as q from './elastic-query'

export const roleAPI = initSplitApi.injectEndpoints({
    reducerPath: 'org',
    endpoints: (builder) => ({

        roleList: builder.query({
            query: (params) => ({
                url: `roles/_search`,
                method: 'POST',
                body: {
                    "query": {
                        "match_all": {}
                    }
                },
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['roleList']
        }),
        getManagers: builder.query({
            query: (params) => ({
                url: `users/_search`,
                method: 'POST',
                body: params.q,
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response;
                    return r
                }
            },
            providesTags: ['orgList']
        }),
        getRoleByCode: builder.query({
            query: (params) => ({
                url: `roles/_search`,
                method: 'POST',
                body: {
                    "query": {
                        "bool": {
                            "must": [
                                {
                                    "match": {
                                        "code.keyword": params.code
                                    }
                                }
                            ]
                        }
                    }
                },
                service: 'elastic'
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.hits?.hits?.length > 0) {
                    var r = response.hits.hits[0]._source;
                    return r
                }
            },
            providesTags: ['orgList']
        }),

    }),

    overrideExisting: false
})

export const {
    useRoleListQuery,
    useGetManagersQuery,
    useGetRoleByCodeQuery
} = roleAPI